import React from 'react';
import { Page } from 'components/shared/Page/Page';
import { TrailUgcProvider } from 'components/trailUgc/TrailUgcContext';
import { Context } from '@alltrails/shared/types/context';
import { Photo } from 'types/Photo';
import Review from 'types/Review';
import TrailUgc, { TrailUgcProps } from '../TrailUgc';
import ItemTotals from '../types/ItemTotals';

type TrailUgcWrapperProps = TrailUgcProps & {
  context: Context;
  reviews: {
    meta: {
      status: string;
      items: number;
      timestamp: string;
    };
    trail_reviews: Review[];
  };
  photos: Photo[];
  itemTotals: ItemTotals;
};

/**
 * A simple component to wrap TrailUgc in required providers to independently function.
 * Used for SSR.
 */
const TrailUgcWrapper = (props: TrailUgcWrapperProps): JSX.Element => {
  const { context, reviews, photos, itemTotals, ...remainingProps } = props;
  return (
    <Page context={context}>
      <TrailUgcProvider
        ugcInfo={{
          reviews: reviews.trail_reviews,
          photos,
          itemTotals
        }}
      >
        <TrailUgc {...remainingProps} />
      </TrailUgcProvider>
    </Page>
  );
};

export default TrailUgcWrapper;
